// Spec 0.4: times are RFC 3339 UTC strings without fractional seconds
// (`2026-10-23T14:05:00Z`) on the wire and in stored records.
const FRACTION = /\.\d{3}Z$/
const ZULU = 'Z'

export function rfc3339(d: Date): string {
  return d.toISOString().replace(FRACTION, ZULU)
}
